/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_V2_Filter_UnfiledInputs */

const en_home_v2_filter_unfiled = /** @type {(inputs: Home_V2_Filter_UnfiledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not in a folder`)
};

const es_home_v2_filter_unfiled = /** @type {(inputs: Home_V2_Filter_UnfiledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin carpeta`)
};

/**
* | output |
* | --- |
* | "Not in a folder" |
*
* @param {Home_V2_Filter_UnfiledInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_filter_unfiled = /** @type {((inputs?: Home_V2_Filter_UnfiledInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_Filter_UnfiledInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_filter_unfiled(inputs)
	return en_home_v2_filter_unfiled(inputs)
});